import { Component, Input } from '@angular/core';

@Component({
    selector: 'custom-tooltip',
    templateUrl: './custom-tooltip.component.html',
    styleUrls: ['./custom-tooltip.component.scss'],
    standalone: false
})
export class CustomTooltipComponent {
  @Input() tooltipMessage: string;
}
